"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/DerivativeImage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _blurhash = require('shared/utils/blurhash');



var _previewSupport = require('shared/utils/previewSupport');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const IMAGE_MAX_WIDTH = 290
const IMAGE_MOBILE_MAX_WIDTH = 200
const IMAGE_MAX_HEIGHT = 320




















const DerivativeImage = ({
  blurHash,
  thumbnailUrl,
  width,
  height,
  fileName,
  onRequestFreshThumbnail,
  onOpenOriginal,
  className,
  children,
}) => {
  const [source, setSource] = _react.useState(thumbnailUrl || null)
  const [loaded, setLoaded] = _react.useState.call(void 0, false)
  const retried = _react.useRef.call(void 0, false)
  const generation = _react.useRef.call(void 0, 0)

  _react.useEffect.call(void 0, () => {
    const currentGeneration = ++generation.current
    setSource(thumbnailUrl || null)
    setLoaded(false)
    retried.current = false
    return () => {
      generation.current = currentGeneration + 1
    }
  }, [thumbnailUrl])

  const placeholder = _react.useMemo.call(void 0, 
    () => blurHash ? _blurhash.decodeBlurhashToDataUri.call(void 0, blurHash) : null,
    [blurHash],
  )
  const hasDimensions = _previewSupport.hasValidImageDerivativeDimensions.call(void 0, width, height)
  const aspectWidth = hasDimensions && typeof width === 'number' ? width : 4
  const aspectHeight = hasDimensions && typeof height === 'number' ? height : 3
  const fitForWidth = (maxWidth) => hasDimensions &&
    typeof width === 'number' && typeof height === 'number'
    ? _previewSupport.fitImageWithin.call(void 0, width, height, maxWidth, IMAGE_MAX_HEIGHT)
    : { width: maxWidth, height: maxWidth * 0.75 }
  const desktopDimensions = fitForWidth(IMAGE_MAX_WIDTH)
  const mobileDimensions = fitForWidth(IMAGE_MOBILE_MAX_WIDTH)
  const imageStyle = {
    '--file-message-image-width': `${desktopDimensions.width}px`,
    '--file-message-image-height': `${desktopDimensions.height}px`,
    '--file-message-image-mobile-width': `${mobileDimensions.width}px`,
    '--file-message-image-mobile-height': `${mobileDimensions.height}px`,
    'aspectRatio': `${aspectWidth} / ${aspectHeight}`,
    'backgroundImage': placeholder ? `url('${placeholder}')` : undefined,
  }

  const handleError = async () => {
    setLoaded(false)
    if (retried.current) return
    retried.current = true
    const refreshGeneration = generation.current
    try {
      const refreshed = await onRequestFreshThumbnail()
      if (refreshed && generation.current === refreshGeneration) setSource(refreshed)
    } catch (_) {
      // The blur placeholder remains visible when a best-effort refresh fails.
    }
  }

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onOpenOriginal()
  }

  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 'file-message--image', className),
      'data-aspect-ratio': `${aspectWidth} / ${aspectHeight}`,
      style: imageStyle,
      role: "button",
      tabIndex: 0,
      'aria-label': fileName,
      onClick: onOpenOriginal,
      onKeyDown: handleKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}

      , source && _react2.default.createElement('img', {
        key: source,
        src: source,
        alt: "",
        className: _classBuilder2.default.call(void 0, 
          'file-message--image--thumbnail',
          loaded && 'file-message--image--thumbnail-loaded',
        ),
        onLoad: () => setLoaded(true),
        onError: handleError, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
      )
      , children
    )
  )
}

exports. default = DerivativeImage
